import { createGlobalStyle } from 'styled-components';
import fonts from './fonts';
import colors from './colors';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    border: 0;
    box-sizing: border-box;
  }

  body {
    color: ${colors.primary}
    background-color: ${colors.white};
    font-family: ${fonts.raleway};
    font-size: 16px;
    overflow-x: hidden;
  }
`;
